export default function removeTrailingZeros(strNumber: string): string {
  const trimmedNumber = parseFloat(strNumber).toString()
  return trimmedNumber
}
